import { v4 } from "uuid";
import * as schemaSubtasks from "~/schemas/schema.subtasks.jsx";
import * as schemaTasks from "~/schemas/schema.tasks.jsx";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";
import * as trashActions from "./actions.trash.jsx";

export const addSubtask = (projectId, taskId, attributes, id = v4()) => {
  return {
    types: [actionTypes.ADD_SUBTASK_LOADING, actionTypes.ADD_SUBTASK_SUCCESS, actionTypes.ADD_SUBTASK_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/tasks/${taskId}/subtasks`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      projectId,
      taskId,
      id,
      attributes,
      schema: {
        single: schemaSubtasks.subtask,
      },
    },
  };
};

export const editSubtask = (projectId, taskId, id, attributes) => {
  return {
    types: [actionTypes.EDIT_SUBTASK_LOADING, actionTypes.EDIT_SUBTASK_SUCCESS, actionTypes.EDIT_SUBTASK_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/tasks/${taskId}/subtasks/${id}`,
        method: `put`,
        body: attributes,
      }),
    payload: {
      projectId,
      taskId,
      id,
      attributes,
      schema: {
        single: schemaSubtasks.subtask,
      },
    },
  };
};

export const completeSubtask = (id) => {
  return {
    types: [
      actionTypes.COMPLETE_SUBTASK_LOADING,
      actionTypes.COMPLETE_SUBTASK_SUCCESS,
      actionTypes.COMPLETE_SUBTASK_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/complete/subtask/${id}`,
        method: `put`,
      }),
    payload: {
      id,
      schema: {
        single: schemaSubtasks.subtask,
      },
    },
  };
};

export const openSubtask = (id) => {
  return {
    types: [actionTypes.OPEN_SUBTASK_LOADING, actionTypes.OPEN_SUBTASK_SUCCESS, actionTypes.OPEN_SUBTASK_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/open/subtask/${id}`,
        method: `put`,
      }),
    payload: {
      id,
      schema: {
        single: schemaSubtasks.subtask,
      },
    },
  };
};

export const moveToTrash = (id) => {
  const objectType = `Subtask`;
  return {
    ...trashActions.moveToTrash(objectType, id),
    types: [
      actionTypes.MOVE_SUBTASK_TO_TRASH_LOADING,
      actionTypes.MOVE_SUBTASK_TO_TRASH_SUCCESS,
      actionTypes.MOVE_SUBTASK_TO_TRASH_ERROR,
    ],
    payload: {
      objectType,
      id,
      schema: {
        single: schemaSubtasks.subtask,
      },
    },
  };
};

export const convertToTask = (projectId, taskId, id) => {
  return {
    types: [
      actionTypes.CONVERT_SUBTASK_TO_TASK_LOADING,
      actionTypes.CONVERT_SUBTASK_TO_TASK_SUCCESS,
      actionTypes.CONVERT_SUBTASK_TO_TASK_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/tasks/${taskId}/subtasks/${id}/promote-to-task`,
        method: `post`,
      }),
    payload: {
      projectId,
      taskId,
      id,
      schema: {
        single: schemaTasks.task,
      },
    },
  };
};

export const reorder = (projectId, taskId, sourceSubtaskId, targetSubtaskId, before = false) => {
  return {
    types: [
      actionTypes.REORDER_SUBTASKS_LOADING,
      actionTypes.REORDER_SUBTASKS_SUCCESS,
      actionTypes.REORDER_SUBTASKS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/tasks/${taskId}/subtasks/reorder`,
        method: `put`,
        body: {
          source_subtask_id: sourceSubtaskId,
          target_subtask_id: targetSubtaskId,
          before,
        },
      }),
    payload: {
      projectId,
      taskId,
      sourceSubtaskId,
      targetSubtaskId,
      before,
    },
  };
};

export const fetchSubtask = (projectId, taskId, id) => {
  return {
    types: [actionTypes.FETCH_SUBTASK_LOADING, actionTypes.FETCH_SUBTASK_SUCCESS, actionTypes.FETCH_SUBTASK_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/tasks/${taskId}/subtasks/${id}`,
        method: `get`,
      }),
    payload: {
      projectId,
      taskId,
      id,
      schema: {
        single: schemaSubtasks.subtask,
      },
    },
  };
};

export const fetchSubtasks = (projectId, taskId) => {
  return {
    types: [actionTypes.FETCH_SUBTASKS_LOADING, actionTypes.FETCH_SUBTASKS_SUCCESS, actionTypes.FETCH_SUBTASKS_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/tasks/${taskId}/subtasks`,
        method: `get`,
      }),
    payload: {
      projectId,
      taskId,
      schema: schemaSubtasks.arrayOfSubtasks,
    },
  };
};

export const fetchSubtasksForTimeline = (projectId) => {
  return {
    types: [
      actionTypes.FETCH_SUBTASKS_TIMELINE_LOADING,
      actionTypes.FETCH_SUBTASKS_TIMELINE_SUCCESS,
      actionTypes.FETCH_SUBTASKS_TIMELINE_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/subtasks-timeline`,
        method: `get`,
      }),
    payload: {
      projectId,
      schema: schemaSubtasks.arrayOfSubtasks,
    },
  };
};

export const batchAddSubtasks = (projectId, taskId, attributes) => {
  return {
    types: [
      actionTypes.BATCH_ADD_SUBTASKS_LOADING,
      actionTypes.BATCH_ADD_SUBTASKS_SUCCESS,
      actionTypes.BATCH_ADD_SUBTASKS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/tasks/${taskId}/subtasks/batch-add`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      projectId,
      taskId,
      attributes,
      schema: schemaSubtasks.arrayOfSubtasks,
    },
  };
};
